module.exports = __webpack_public_path__ + "static/media/p_frv_Manimal.92703a30.png";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Pcg/p_frv_Manimal.png
// module id = 548
// module chunks = 0